export default "__VITE_ASSET__CCI34MzV__"